import { render, staticRenderFns } from "./ManualTransaction.vue?vue&type=template&id=66ded526&"
import script from "./ManualTransaction.vue?vue&type=script&lang=js&"
export * from "./ManualTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ManualTransaction.vue?vue&type=style&index=0&id=66ded526&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports